var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_30535",
    "data-name": "Group 30535",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.018,
    height: 34.018,
    viewBox: "0 0 34.018 34.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 12.027,
    cy: 12.027,
    r: 12.027,
    transform: "translate(17.009 34.018) rotate(-135)",
    fill: "#05132e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-instagram-11",
    d: "M7.148,1.289c1.91,0,2.136.007,2.891.042a2.688,2.688,0,0,1,2.933,2.932c.034.754.041.981.041,2.891s0,2.136-.041,2.891a2.688,2.688,0,0,1-2.927,2.927c-.754.034-.98.042-2.891.042s-2.136,0-2.891-.042A2.688,2.688,0,0,1,1.33,10.045c-.034-.754-.041-.981-.041-2.9s.008-2.136.042-2.891A2.688,2.688,0,0,1,4.264,1.33C5.018,1.3,5.244,1.289,7.148,1.289ZM7.148,0C5.211,0,4.968.008,4.205.042A3.948,3.948,0,0,0,.044,4.2C.008,4.968,0,5.211,0,7.148S.008,9.341.042,10.1A3.948,3.948,0,0,0,4.2,14.265c.764.034,1.007.042,2.95.042s2.187-.008,2.95-.042a3.948,3.948,0,0,0,4.16-4.162c.036-.764.044-1.007.044-2.95S14.3,4.966,14.266,4.2A3.948,3.948,0,0,0,10.1.044C9.341.008,9.1,0,7.148,0Zm0,3.48a3.674,3.674,0,1,0,3.68,3.668A3.674,3.674,0,0,0,7.148,3.48Zm0,6.058A2.383,2.383,0,1,1,9.53,7.156,2.383,2.383,0,0,1,7.148,9.538Zm3.825-7.062a.859.859,0,1,0,.858.859.859.859,0,0,0-.858-.859Z",
    transform: "translate(9.902 10.165)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.87c8e49c9cce00c8ab35d250fd7b86d4.svg";
export { ForwardRef as ReactComponent };